import { useMemo } from 'react'
import { Button, SelectMultiple } from '~/components/ui'

type CityFilterProps = {
  cityValues: string[]
  filterCity: string[]
  updateFilter: (key: string, value: any) => void
}

export default function CityFilter({
  cityValues,
  filterCity,
  updateFilter,
}: CityFilterProps) {
  const cityData = useMemo(
    () =>
      cityValues.map((city) => {
        return { label: city, value: city }
      }),
    [cityValues]
  )

  const selectedCities = useMemo(
    () => cityData.filter(({ value }) => filterCity.includes(value)),
    [filterCity, cityData]
  )

  return (
    <div className="space-y-2">
      <p className="text-sm">
        City
        {selectedCities.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter('cities', undefined)}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultiple
        scrollIntoView
        placeholder="Search cities..."
        options={cityData}
        selected={selectedCities}
        setSelected={(selected) => {
          updateFilter(
            'cities',
            selected.map(({ value }) => value)
          )
        }}
      />
    </div>
  )
}
